<template>
  <div class="activities-manage-container animated fadeInRight">
    <div class="page-content">
      <!-- 页面标题 -->
      <div class="page-title">{{ $t('activitiesManage.list.title') }}</div>

      <!-- 工具栏 -->
      <div class="oa-list-toolbar">
        <el-button size="small" class="add-btn" @click="_openAddActivitiesModal">
          <i class="el-icon-plus"></i>
          {{ $t('common.add') }}
        </el-button>
        <el-button class="icon-reset-btn" @click="_resetActivitiesMethod">
          <i class="el-icon-refresh-right"></i>
        </el-button>

        <div class="filter-group activities-filter-group">
          <el-input v-model="activitiesManageInfo.conditions.activitiesId" :placeholder="$t('activitiesManage.search.activitiesId')" class="filter-input" clearable />
          <el-input v-model="activitiesManageInfo.conditions.title" :placeholder="$t('activitiesManage.search.title')" class="filter-input" clearable />
          <el-select v-model="activitiesManageInfo.conditions.typeCd" :placeholder="$t('activitiesManage.search.typeCd')" class="filter-select">
            <el-option v-for="item in activitiesManageInfo.typeCds" :key="item.typeCd" :label="item.typeName" :value="item.typeCd" />
          </el-select>
          <el-input v-model="activitiesManageInfo.conditions.staffName" :placeholder="$t('activitiesManage.search.staffName')" class="filter-input" clearable />
        </div>

        <div class="toolbar-right">
          <el-button class="search-btn" @click="_queryActivitiesMethod">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
        </div>
      </div>

      <!-- 列表 -->
      <el-table :data="activitiesManageInfo.activitiess" stripe class="data-table" style="width: 100%" :fit="true">
        <el-table-column prop="communityName" :label="$t('activitiesManage.table.communityName')" align="center" min-width="174" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.communityName || scope.row.communityNames || scope.row.community_name || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="activitiesId" :label="$t('activitiesManage.table.activitiesId')" align="center" min-width="112" />
        <el-table-column prop="title" :label="$t('activitiesManage.table.title')" align="center" min-width="230" show-overflow-tooltip />
        <el-table-column :label="$t('activitiesManage.table.typeCd')" align="center" min-width="186">
          <template slot-scope="scope">
            {{ getActivityTypeName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" :label="$t('activitiesManage.table.startTime')" align="center" min-width="234" />
        <el-table-column prop="endTime" :label="$t('activitiesManage.table.endTime')" align="center" min-width="234" />
        <el-table-column prop="userName" :label="$t('activitiesManage.table.userName')" align="center" min-width="234" />
        <el-table-column :label="$t('common.operation')" align="center" min-width="176">
          <template slot-scope="scope">
            <el-button type="text" class="edit-btn" @click="_openEditActivitiesModel(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button type="text" class="delete-btn" @click="_openDeleteActivitiesModel(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" class="pagination-bar" />
    </div>

    <add-activities-view ref="addActivitiesView" @success="handleSuccess" />
    <edit-activities-view ref="editActivitiesView" @success="handleSuccess" />
    <delete-activities ref="deleteActivities" @success="handleSuccess" />
  </div>
</template>

<script>
import { getEffectiveCommunityId, getMyEnteredCommunitys } from '@/api/community/communityApi'
import { listActivities, listActivitiesType } from '@/api/oa/activitiesManageApi'
import AddActivitiesView from '@/components/oa/addActivitiesView'
import EditActivitiesView from '@/components/oa/editActivitiesView'
import DeleteActivities from '@/components/oa/deleteActivities'
import { getActivityTypeName, normalizeActivityTypes } from '@/utils/oaActivityTypes'

export default {
  name: 'ActivitiesManageList',
  components: {
    AddActivitiesView,
    EditActivitiesView,
    DeleteActivities
  },
  data() {
    return {
      activitiesManageInfo: {
        activitiess: [],
        total: 0,
        records: 1,
        moreCondition: false,
        title: '',
        typeCds: [],
        conditions: {
          title: '',
          typeCd: '',
          staffName: '',
          activitiesId: '',
        endTimeFlag: '1',
        page: 1,
        row: 10,
        communityId: '',
        communityIds: ''
      }
      },
      authorizedCommunityIds: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  async created() {
    this.communityId = getEffectiveCommunityId()
    this.activitiesManageInfo.conditions.communityId = ''
    await this.loadAuthorizedCommunitys()
    this._listActivitiess()
    this._loadActivitiesType()
  },
  methods: {
    async loadAuthorizedCommunitys() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 1000 })
        this.authorizedCommunityIds = (res.communitys || [])
          .map(item => getEffectiveCommunityId(item.communityId))
          .filter(Boolean)
      } catch (error) {
        this.authorizedCommunityIds = []
      }
    },
    async _listActivitiess() {
      try {
        const params = {
          ...this.activitiesManageInfo.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listActivities(params)
        this.activitiesManageInfo.activitiess = data
        this.page.total = total
      } catch (error) {
        console.error('获取活动列表失败:', error)
      }
    },
    async _loadActivitiesType() {
      try {
        const params = {
          page: 1,
          row: 50,
          communityId: this.communityId
        }
        const { data } = await listActivitiesType(params)
        this.activitiesManageInfo.typeCds = normalizeActivityTypes(data)
      } catch (error) {
        console.error('获取活动类型失败:', error)
      }
    },
    _openAddActivitiesModal() {
      this.$refs.addActivitiesView.open()
    },
    _openEditActivitiesModel(row) {
      this.$refs.editActivitiesView.open(row)
    },
    _openDeleteActivitiesModel(row) {
      this.$refs.deleteActivities.open(row)
    },
    _queryActivitiesMethod() {
      this.page.current = 1
      this._listActivitiess()
    },
    _resetActivitiesMethod() {
      this.activitiesManageInfo.conditions = {
        title: '',
        typeCd: '',
        staffName: '',
        activitiesId: '',
          endTimeFlag: '1',
          page: 1,
          row: 10,
          communityId: '',
          communityIds: ''
        }
      this._listActivitiess()
    },
    getActivityTypeName(row) {
      return getActivityTypeName(row)
    },
    handleSuccess() {
      this._listActivitiess()
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listActivitiess()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listActivitiess()
    }
  }
}
</script>

<style lang="scss" scoped>
.activities-manage-container {
  padding: 20px;
  background-color: #EBF2FA;
  min-height: calc(100vh - 84px);
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;

  .page-content {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 22px 24px;
  }

  .page-title {
    font-size: 16px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 600;
    color: #1D2129;
    padding-bottom: 20px;
    border-bottom: 1px solid #DCE6F5;
    margin-bottom: 20px;
    text-align: left;
  }

  .oa-list-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;

    .add-btn {
      width: 82px;
      height: 38px;
      border-radius: 10px;
      background: #0E76FF;
      border: none;
      color: #FFFFFF;
      font-family: 'Inter', 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;

      &:hover {
        background: #1C99FF;
      }

      i {
        font-size: 12px;
      }
    }

    .filter-group {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      justify-content: flex-end;

      .filter-select,
      .filter-input {
        width: 256px;

        ::v-deep .el-input__inner {
          border-radius: 10px;
          border: 1px solid #DCE6F5;
          background: #FFFFFF;
          font-family: 'Inter', 'PingFang SC', sans-serif;
          font-size: 14px;
          color: #1D2129;
          height: 38px;
          line-height: 38px;

          &::placeholder {
            color: #8C9BB4;
          }

          &:focus {
            border-color: #0E76FF;
          }
        }
      }

      .more-btn {
        color: #0E76FF;
        font-size: 14px;
        padding: 0;
        font-family: 'PingFang SC', sans-serif;

        &:hover {
          color: #4D9FFF;
        }
      }
    }

    .toolbar-right {
      display: flex;
      align-items: center;
      gap: 8px;

      .search-btn {
        width: 84px;
        height: 38px;
        border-radius: 10px;
        background: #FFFFFF;
        border: 1px solid #0E76FF;
        color: #0E76FF;
        font-family: 'Inter', 'PingFang SC', sans-serif;
        font-weight: 500;
        font-size: 14px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        &:hover {
          background: #E8F3FF;
        }

        i {
          font-size: 12px;
        }
      }

      .reset-btn {
        width: 84px;
        height: 38px;
        border-radius: 10px;
        background: #FFFFFF;
        border: 1px solid #DCE6F5;
        color: #364153;
        font-family: 'Inter', 'PingFang SC', sans-serif;
        font-weight: 500;
        font-size: 14px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        &:hover {
          background: #F2F3F5;
        }

        i {
          font-size: 12px;
        }
      }
    }
  }

  .oa-list-toolbar {
    display: grid;
    grid-template-columns: 82px 38px 1fr 84px;
    column-gap: 12px;

    .icon-reset-btn {
      width: 38px;
      height: 38px;
      border-radius: 10px;
      border: 1px solid #DCE6F5;
      background: #FFFFFF;
      color: #8C9BB4;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 14px;
      }

      &:hover {
        background: #F8FBFF;
        border-color: #DCE6F5;
        color: #0E76FF;
      }
    }

    .activities-filter-group {
      justify-content: end;
    }
  }

  .data-table {
    width: 100%;
    border-radius: 10px;
    overflow: hidden;

    &::before {
      display: none;
    }

    ::v-deep .el-table__header-wrapper {
      th {
        background-color: #EBF2FA !important;
        color: #364153 !important;
        font-weight: 400;
        font-size: 14px;
        font-family: 'PingFang SC', sans-serif;
        padding: 12px 0;
        height: 50px;
      }
    }

    ::v-deep .el-table__row--striped td {
      background-color: #F8FBFF !important;
    }

    ::v-deep .el-table__body tr:hover > td {
      background-color: #E8F3FF !important;
    }

    ::v-deep td {
      color: #1D2129;
      font-size: 14px;
      font-family: 'PingFang SC', sans-serif;
      padding: 12px 0;
      height: 50px;
    }

    ::v-deep .edit-btn,
    ::v-deep .delete-btn {
      border-radius: 0;
      background: transparent;
      border: none;
      padding: 0 8px;
      color: #0E76FF;
      font-size: 14px;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 400;

      &:hover {
        color: #1C99FF;
        background: transparent;
      }
    }
  }

  .pagination-bar {
    margin-top: 20px;
    text-align: right;

    ::v-deep .el-pagination__total,
    ::v-deep .el-pagination__jump {
      color: #1D2129;
      font-size: 14px;
      font-family: 'PingFang SC', sans-serif;
    }

    ::v-deep .el-pager li {
      border-radius: 2px;
      width: 32px;
      height: 32px;
      line-height: 32px;

      &.active {
        background-color: #E8F3FF !important;
        color: #0E76FF !important;
        border-radius: 8px;
        font-family: 'Nunito Sans', sans-serif;
        font-weight: 600;
      }
    }

    ::v-deep .el-pagination__sizes .el-input__inner {
      background: #F2F3F5;
      border-radius: 8px;
      border: none;
      height: 32px;
      line-height: 32px;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 2px;
    }
  }

  .no_display {
    display: none;
  }
}
</style>
